var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"apply-button"},on:{"click":_vm.toRegister}},[_c('p',{class:{ 'fs-medium-1': true, 'is-white-button': _vm.$router.currentRoute.path == '/register' }},[_vm._v(" "+_vm._s(_vm.$t("global.button-apply"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }